<template>
	<div>
		<questions @singleAnswer='({it,i,index})=>{singleAnswer(it,i,index)}' @multipleAnswer='({it,i,index})=>{multipleAnswer(it,i,index)}' @blanksAnswer='({index})=>{blanksAnswer(index)}' :questionsubmit='true' :qusetionlist='qusetionlist' :questionindex='questionindex'></questions>
		<div class="videotopic">
			<el-button type='primary' @click='addAnswer' v-show='!qusetionlist[questionindex].overdata'>提交</el-button>
			<el-button type='success' @click='closeAsk' v-show='qusetionlist[questionindex].overdata && qusetionlist[questionindex].userAnswer == qusetionlist[questionindex].answer'>关闭</el-button>
			<el-button type='danger' @click='reAnswer' v-show='qusetionlist[questionindex].overdata && qusetionlist[questionindex].userAnswer != qusetionlist[questionindex].answer'>再看一次</el-button>
			<el-button type='primary' @click='skipAsk' v-show='qusetionlist[questionindex].overdata && qusetionlist[questionindex].userAnswer != qusetionlist[questionindex].answer && qusetionlist[questionindex].isSkip == "1"'>跳过此题</el-button>
		</div>
	</div>
</template>

<script>
	import { addAskTopicAnswer } from "@/api/course.js"
	import questions from '@/components/questions.vue'
	export default {
		name: 'task',
		components: {
			questions
		},
		props: {
			qusetionlist: Array,
			questionindex: Number,
		},
		data() {
			return {

			}
		},
		created() {
			this.formInit();
		},
		methods: {
			formInit() {
				var qusetionlist = this.qusetionlist;
				qusetionlist.map(item => {
					item.over = false;
					item.overdata = false;
					item.choose = [];
					item.filesurl = '';
					item.filearr = [];
					item.userAnswer = '';
					if(item.topicType == 4 || item.topicType == 5) {
						this.isSubjectiveItem = true;
					}
					if(item.isFile == 1 && item.fileName != null) {
						var files = JSON.parse(item.fileName);
						item.files = files;
						var openfiles = [];
						files.map(item => {
							var openurl = this.baseurl + item.url;
							openfiles.push(openurl)
						})
						item.openfiles = openfiles;
					}
					var answerlist = [];
					if(item.optionA != '' && item.optionA != null) {
						if(item.optionA.indexOf('@') == -1) {
							answerlist[0] = {
								type: '1',
								label: 'A',
								value: item.optionA,
							}
						} else {
							answerlist[0] = {
								type: '2',
								label: 'A',
								value: item.optionA.slice(1),
							}
						}
					}
					if(item.optionB != '' && item.optionB != null) {
						if(item.optionB.indexOf('@') == -1) {
							answerlist[1] = {
								type: '1',
								label: 'B',
								value: item.optionB,
							}
						} else {
							answerlist[1] = {
								type: '2',
								label: 'B',
								value: item.optionB.slice(1),
							}
						}
					}
					if(item.optionC != '' && item.optionC != null) {
						if(item.optionC.indexOf('@') == -1) {
							answerlist[2] = {
								type: '1',
								label: 'C',
								value: item.optionC,
							}
						} else {
							answerlist[2] = {
								type: '2',
								label: 'C',
								value: item.optionC.slice(1),
							}
						}
					}
					if(item.optionD != '' && item.optionD != null) {
						if(item.optionD.indexOf('@') == -1) {
							answerlist[3] = {
								type: '1',
								label: 'D',
								value: item.optionD,
							}
						} else {
							answerlist[3] = {
								type: '2',
								label: 'D',
								value: item.optionD.slice(1),
							}
						}
					}
					if(item.optionE != '' && item.optionE != null) {
						if(item.optionE.indexOf('@') == -1) {
							answerlist[4] = {
								type: '1',
								label: 'E',
								value: item.optionE,
							}
						} else {
							answerlist[4] = {
								type: '2',
								label: 'E',
								value: item.optionE.slice(1),
							}
						}
					}
					if(item.optionF != '' && item.optionF != null) {
						if(item.optionF.indexOf('@') == -1) {
							answerlist[5] = {
								type: '1',
								label: 'F',
								value: item.optionF,
							}
						} else {
							answerlist[5] = {
								type: '2',
								label: 'F',
								value: item.optionF.slice(1),
							}
						}
					}
					item.answerlist = answerlist;
				})
				this.qusetionlist = qusetionlist;
			},
			skipAsk() {
				this.$emit('skipAsk')
			},
			closeAsk() {
				this.$emit('closeAsk')
			},
			reAnswer() {
				var qusetionlist = this.qusetionlist;
				var index = this.questionindex;
				qusetionlist[index].overdata = false;
				qusetionlist[index].userAnswer = '';
				qusetionlist[index].over = false;
				qusetionlist[index].choose = [];
				this.$set(this.qusetionlist, index, qusetionlist[index]);
				this.$emit('relookAsk')
			},
			addAnswer() {
				var qusetionlist = this.qusetionlist;
				var index = this.questionindex;
				if(qusetionlist[index].over == true) {
					qusetionlist[index].userAnswer = qusetionlist[index].choose.join('');
					qusetionlist[index].overdata = true;
					this.$set(this.qusetionlist, index, qusetionlist[index]);
					this.uploadQuestion(qusetionlist[index]);
				} else {
					this.$message({
						type: 'error',
						message: '请先作答！'
					})
				}
			},
			uploadQuestion(item) {
				var data = {
					askTopicId: item.id,
					userAnswer: item.userAnswer,
				}
				addAskTopicAnswer(data).then(res => {
					if(item.userAnswer == item.answer) {
						this.$message({
							type: 'success',
							message: '答对了！'
						})
					} else {
						this.$message({
							type: 'error',
							message: '答错了！'
						})
					}
				})
			},
			singleAnswer(it, i, index) {
				var qusetionlist = this.qusetionlist;
				if(!qusetionlist[index].overdata) {
					var choose = [it.label];
					qusetionlist[index].choose = choose;
					qusetionlist[index].over = true;
					this.$set(this.qusetionlist, index, qusetionlist[index])
				}
			},
			multipleAnswer(it, i, index) {
				var qusetionlist = this.qusetionlist;
				if(!qusetionlist[index].overdata) {
					var choose = qusetionlist[index].choose;
					if(choose.indexOf(it.label) == -1) {
						choose.push(it.label)
					} else {
						var deleteIndex = choose.indexOf(it.label);
						choose.splice(deleteIndex, 1)
					}
					choose = choose.sort();
					qusetionlist[index].choose = choose;
					if(choose.length > 0) {
						qusetionlist[index].over = true;
					} else {
						qusetionlist[index].over = false;
					}
					this.$set(this.qusetionlist, index, qusetionlist[index])
				}
			},
			blanksAnswer(index) {
				var qusetionlist = this.qusetionlist;
				if(qusetionlist[index].userAnswer.length > 0) {
					qusetionlist[index].over = true;
				} else {
					qusetionlist[index].over = false;
				}
			},
		},
	}
</script>
<style type="text/css">
	.videotopic {
		margin: 15px 0 0 0;
		text-align: center;
	}
	
	.videotopic button {
		margin: 0 15px;
	}
</style>